import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const SandboxWorkFlowGetList = createAsyncThunk(
    "SandboxWorkFlowGetList",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.SANDBOXWORKFLOW.GETLIST,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const SandboxWorkFlowSave = createAsyncThunk(
    "SandboxWorkFlowSave",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.SANDBOXWORKFLOW.SAVE,
                    body: data,
                },
                true
            );
            let response = apiResponse(true, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const GetSandboxWorkFlowByID = createAsyncThunk(
    "GetSandboxWorkFlowByID",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.SANDBOXWORKFLOW.GETBYDETAILS,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const ConverWorkflowAsSandbox = createAsyncThunk(
    "ConverWorkflowAsSandbox",
    async (data, { dispatch }) => {
        try {
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.SANDBOXWORKFLOW.CONVERWORKFLOWASSANDBOX,
                    body: data,
                },
                true
            );
            let response = apiResponse(true, resData);
            return response;
        } catch (error) { }
    }
);


const initialState = {
    SandboxWorkFlowGetListData: {
        data: null,
        error: null,
    },

    SandboxWorkFlowSaveData: {
        data: null,
        error: null,
    },

    SandboxGetWorkFlowByIDData: {
        data: null,
        error: null,
    },

    isLoading: false,
};

const SandboxWorkFlowSlice = createSlice({
    name: "SandboxWORKFLOW",
    initialState,

    reducers: {
        setLoader: (state, action) => {
            state.isLoading = action.payload;
        },

        setSandboxWorkFlowGetListData: (state) => {
            state.SandboxWorkFlowGetListData.data = null;
            state.SandboxWorkFlowGetListData.error = null;
        },

        setSandboxGetWorkFlowByID: (state) => {
            state.SandboxGetWorkFlowByIDData.data = null;
            state.SandboxGetWorkFlowByIDData.error = null;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(SandboxWorkFlowGetList.fulfilled, (state, action) => {
                state.SandboxWorkFlowGetListData.data = action.payload;
            })

            .addCase(SandboxWorkFlowGetList.rejected, (state, action) => {
                state.SandboxWorkFlowGetListData.error = action.error.message;
            })

            .addCase(SandboxWorkFlowSave.fulfilled, (state, action) => {
                state.SandboxWorkFlowSaveData.data = action.payload;
            })

            .addCase(SandboxWorkFlowSave.rejected, (state, action) => {
                state.SandboxWorkFlowSaveData.error = action.error.message;
            })

            .addCase(GetSandboxWorkFlowByID.fulfilled, (state, action) => {
                state.SandboxGetWorkFlowByIDData.data = action.payload;
            })

            .addCase(GetSandboxWorkFlowByID.rejected, (state, action) => {
                state.SandboxGetWorkFlowByIDData.error = action.error.message;
            });
    },
});

export const {
    setLoader,
    setSandboxWorkFlowGetListData,
    setSandboxGetWorkFlowByID

} = SandboxWorkFlowSlice.actions;
export default SandboxWorkFlowSlice.reducer;
